<script>

    export let value
    export let placeholder = null
    export let label = null

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <textarea bind:value={value} class="textarea" { placeholder }></textarea>
    </div>
</div>
